import { JhText } from "designPackages/textPackage";

interface StatusBadgeProps {
  label: string;
  textColorClass?: string;
  bgColorClass?: string;
  showEllipse?: boolean;
  variant?:
  | "subtitle5"
  | "caption1"
  | "caption2"
  | "body2"
  | "subtitle4"
  | "subtitle3";
  className?: string;
  ellipseColorClass?: string;
}

const StatusBadge = ({
  label,
  textColorClass = "",
  bgColorClass = "",
  showEllipse = true,
  variant = "subtitle5",
  className = "",
  ellipseColorClass = ""
}: StatusBadgeProps) => {

  return (
    <div
      id="th-v2-status-badge-container"
      className={`inline-flex items-center gap-1 px-2 py-1 rounded ${bgColorClass} ${className}`}
    >
      {showEllipse && (
        <div
          id="th-v2-status-badge-ellipse"
          className={`w-1 h-1 rounded-full ${ellipseColorClass}`}
        />
      )}

      <JhText variant={variant} className={textColorClass}>
        {label}
      </JhText>
    </div>
  );
};

export default StatusBadge;
